module.exports = __webpack_public_path__ + "img/lock-login-icon.e6a5aa71.svg";